export default (url: string, title: string, callback?: () => void): void => {
  const height = Math.round(window.innerHeight)
  const width = Math.round(window.innerWidth * 3.5)
  const top = window.screen.height / 2 - height / 2
  const left = window.screen.width / 2 - width / 2
  const options = `_blank,height=${height},width=${width},top=${top},left=${left}`
  const winObj = window.open(url, title, options)
  const loop = setInterval(() => {
    if (winObj?.closed) {
      clearInterval(loop)

      if (callback) {
        callback()
      }
    }
  }, 1000)
}
